import { useQuery } from "@tanstack/react-query";
import { getTenant } from "../api";

export const useGetTenant = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["TENANT"],
    queryFn: getTenant,
    select: ({ data }) => data,
  });

  return { tenant: data, isLoading };
};
